import PropTypes from 'prop-types'
import React from 'react'
import BoardUsers from 'routes/Board/Users'

export class Users extends React.Component {
  static propTypes = {
    responsible: PropTypes.number,
    users: PropTypes.array.isRequired,
    onAddUser: PropTypes.func.isRequired,
    onRemoveUser: PropTypes.func.isRequired
  }

  render () {
    const {
      responsible,
      users,
      onAddUser,
      onRemoveUser,
      ...props
    } = this.props

    const getBoardUserProps = (user) => {
      const isAdded =
        user.id === responsible ||
        users.indexOf(user.id) !== -1

      let onClick
      if (!isAdded) {
        onClick = () => onAddUser(user)
      } else {
        onClick = () => onRemoveUser(user)
      }

      return {
        defaultMenu: user.listItem && user.defaultMenu,
        onClick,
        active: isAdded
      }
    }

    return (
      <BoardUsers
        {...props}
        getUserProps={getBoardUserProps}
        showPermissionGroups={false}
      />
    )
  }
}

export default Users
